import type { ComponentInfo } from "@builder.io/sdk-react";

export const CATEGORY_FILTERS_INPUTS = [
  {
    name: "subcategoriesWithProductCount",
    type: "list",
    subFields: [
      {
        name: "name",
        type: "string",
        defaultValue: "",
      },
      {
        name: "checked",
        type: "boolean",
        defaultValue: true,
      },
      {
        name: "uid",
        type: "string",
        defaultValue: "",
      },
      {
        name: "productCount",
        type: "number",
        defaultValue: "",
      },
      {
        name: "withSlug",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "image",
        type: "string",
        defaultValue: "",
      },
      {
        name: "newBadge",
        type: "string",
        defaultValue: "",
      },
    ],
    defaultValue: [],
  },
  {
    name: "isProductCountVisible",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies ComponentInfo["inputs"];

export type CategoryFiltersProps = BuilderComponentProps<typeof CATEGORY_FILTERS_INPUTS>;
